import React from 'react';
import { connectLean } from 'lean-redux';
import { connect } from 'react-redux';
import AssignItem from 'legacy/src/components/assessment/AssignItem';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import connectLeanUpdateAssignments from 'chameleon-src/utility/connectLeanUpdateAssignments';

const UnassignedAssignment = ({
  resource,
  assessmentId,
  isAdminOrCoordinator,
  saveAssignedState,
  onItemAction,
  useNewAssignModalFlag,
  studentsBySection,
}) => {
  const { displayName } = resource;

  /**
   * On assign callback
   * */
  const onAssignItem = (assignmentsResponse, totalAssignees) => {
    connectLeanUpdateAssignments({
      assignmentsResponse,
      totalAssignees,
      saveAssignedState,
      onItemAction,
      useNewAssignModalFlag,
      studentsBySection,
    });
  };

  return (
    <AssignItem
      isSPP
      selectedGroups={{}}
      groups={[]}
      itemId={Number.parseInt(assessmentId, 10)}
      itemTitle={displayName}
      onAssignRedirect={false}
      onAssign={onAssignItem}
      button={
        <ButtonWithIcon
          tabIndex={0}
          isPrimary
          icon="person_add"
          iconClassName="fill-current text-white"
          accessibility={{
            'aria-label': 'Assign Quiz',
          }}
        >
          Assign
        </ButtonWithIcon>
      }
      isAdminOrCoordinator={isAdminOrCoordinator}
    />
  );
};

const mapStateToProps = ({ featureFlag, studentsBySection }) => {
  return {
    useNewAssignModalFlag: featureFlag.new_assign_modal,
    studentsBySection,
  };
};

export default connectLean({
  saveAssignedState(updatedAssignmentsInfo, assignResponse) {
    const { assessmentId, assignResponses = [] } = this.state;
    this.setState({
      isAssigned: true,
      sppAssignments: {
        [assessmentId]: [
          { assessmentId, isAssigned: true, updatedAssignmentsInfo },
        ],
      },
      assignResponses: [...(assignResponses || []), ...(assignResponse || [])],
    });
  },
})(connect(mapStateToProps)(UnassignedAssignment));
